module.exports = function() {
  return new Worker(__webpack_public_path__ + "275b9024981ae6288672.worker.js");
};